import createCS from '~/assets/examples/createCS.json'
import checkCS from '~/assets/examples/checkCS.json'
import updateCS from '~/assets/examples/updateCS.json'
import infoCS from '~/assets/examples/infoCS.json'
import createGO from '~/assets/examples/createGO.json'
import checkGO from '~/assets/examples/checkGO.json'
import updateGO from '~/assets/examples/updateGO.json'
import infoGO from '~/assets/examples/infoGO.json'
import createJava from '~/assets/examples/createJava.json'
import checkJava from '~/assets/examples/checkJava.json'
import updateJava from '~/assets/examples/updateJava.json'
import infoJava from '~/assets/examples/infoJava.json'
import createJS from '~/assets/examples/createJS.json'
import checkJS from '~/assets/examples/checkJS.json'
import updateJS from '~/assets/examples/updateJS.json'
import infoJS from '~/assets/examples/infoJS.json'
import createPHP from '~/assets/examples/createPHP.json'
import checkPHP from '~/assets/examples/checkPHP.json'
import updatePHP from '~/assets/examples/updatePHP.json'
import infoPHP from '~/assets/examples/infoPHP.json'
import createPython from '~/assets/examples/createPython.json'
import checkPython from '~/assets/examples/checkPython.json'
import updatePython from '~/assets/examples/updatePython.json'
import infoPython from '~/assets/examples/infoPython.json'

export const useDevelopersCode = () => {
  const currentLang = useState<string>('currentCode', () => 'c-sharp');
  const currentTab = useState<string>('currentTab', () => 'create');
  const currentContent = useState('currentContent', () => '')

  const content: any = {
    'c-sharp': {
      create: createCS,
      check: checkCS,
      update: updateCS,
      info: infoCS,
    },
    go: {
      create: createGO,
      check: checkGO,
      update: updateGO,
      info: infoGO,
    },
    java: {
      create: createJava,
      check: checkJava,
      update: updateJava,
      info: infoJava,
    },
    nodejs: {
      create: createJS,
      check: checkJS,
      update: updateJS,
      info: infoJS,
    },
    php: {
      create: createPHP,
      check: checkPHP,
      update: updatePHP,
      info: infoPHP,
    },
    python: {
      create: createPython,
      check: checkPython,
      update: updatePython,
      info: infoPython,
    },
  }

  const setLang = (lang: string) => {
    currentLang.value = lang;
  };

  const setTab = (tab: string) => {
    currentTab.value = tab;
  };

  const setContent = () => {
    currentContent.value = content[currentLang.value][currentTab.value].code;
  }

  onMounted(() => {
    setContent();
  });

  return {
    currentLang,
    currentTab,
    currentContent,
    setLang,
    setTab,
    setContent,
  }
}